import { motion } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'Para quantas pessoas são as cabanas?',
    answer: 'Cada cabana é pensada para até 2 pessoas, sendo ideal para casais que buscam privacidade e uma experiência romântica a dois. Já a Casa M5 acomoda até 10 pessoas, perfeita para famílias e grupos.'
  },
  {
    question: 'Posso levar meu pet?',
    answer: 'Sim! Somos pet friendly. Cobramos uma taxa de R$ 200,00 para higienização do espaço após a hospedagem com animais de estimação.'
  },
  {
    question: 'A piscina é aquecida?',
    answer: 'Sim! Ambas as cabanas possuem piscina privativa aquecida, perfeita para aproveitar em qualquer época do ano.'
  },
  {
    question: 'Como chegar às cabanas?',
    answer: 'As cabanas estão localizadas em condomínio fechado na Barra de Guaratiba. O acesso é por uma subida íngreme, então recomendamos veículo com pneus em bom estado. Se for de Uber, sugerimos a categoria Black.'
  },
  {
    question: 'Qual o horário de check-in e check-out?',
    answer: 'O check-in é realizado a partir das 15h e o check-out até as 12h. Horários diferenciados podem ser negociados diretamente conosco via WhatsApp.'
  },
  {
    question: 'As cabanas possuem cozinha?',
    answer: 'Sim! Todas as nossas acomodações possuem cozinha completa equipada com Air Fryer, Cafeteira Nespresso e todos os utensilios necessários.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-24 md:py-32 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-accent mb-4">
            Perguntas Frequentes
          </p>
          <h2 className="text-4xl md:text-5xl font-light tracking-tight text-primary">
            Dúvidas Comuns
          </h2>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-soft overflow-hidden"
            >
              <button
                data-testid={`faq-question-${index}`}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-muted/50 transition-colors"
              >
                <span className="text-lg font-semibold text-primary pr-8">{faq.question}</span>
                <ChevronDown
                  size={24}
                  className={`text-accent flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div
                data-testid={`faq-answer-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-12 text-center"
        >
          <p className="text-base text-muted-foreground mb-6">
            Não encontrou a resposta que procurava?
          </p>
          <a
            data-testid="faq-whatsapp-link"
            href="https://wa.me/5521996273547"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-primary text-white hover:bg-primary/90 rounded-full px-8 py-4 text-sm uppercase tracking-widest transition-all hover:scale-105"
          >
            Fale Conosco no WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;